import React from "react";
import clsx from "clsx";
import AuthBgLines from "../../../../assets/images/auth-bg-lines.png";
import MergeLogo from "../../../../assets/svg/logos/merge/logo.svg";
import DashboardBackdrop from "./DashboardBackdrop";

interface Props {
  children: React.ReactNode;
  /** Step 2 — render Stripe-style fake dashboard behind the card. Mutually exclusive with embossed background. */
  backdrop?: boolean;
  /** Content rendered below the card (TrustedByPanel on Step 1). */
  belowCard?: React.ReactNode;
  cardMaxWidth?: string;
}

const AuthPageWrapper = ({
  children,
  backdrop = false,
  belowCard,
  cardMaxWidth = "max-w-[472px]",
}: Props) => (
  <div
    className={clsx("relative min-h-screen flex flex-col", !backdrop && "bg-[#FAF8F5]")}
    style={
      !backdrop
        ? {
            backgroundImage: `url(${AuthBgLines})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }
        : undefined
    }
  >
    {backdrop && <DashboardBackdrop />}
    {!backdrop && (
      <div className="absolute top-0 left-0 p-6">
        <img src={MergeLogo} alt="Merge" className="h-6" />
      </div>
    )}
    <main className="flex-1 flex flex-col items-center px-4 pt-[108px] pb-12">
      <div className="w-full max-w-[960px] flex flex-col items-center gap-16">
        <div className={clsx("w-full flex justify-center", cardMaxWidth)}>{children}</div>
        {belowCard && <div className="w-full">{belowCard}</div>}
      </div>
    </main>
  </div>
);

export default AuthPageWrapper;
